(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-slider"] && !Shopify.designMode) return;
  try {
    
  class BeforeAfterComponent extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.querySelector('[data-ref="wrapper"]');
      this.afterEl = this.querySelector('[data-ref="after"]');
      this.handle = this.querySelector('[data-ref="handle"]');
      if (!this.wrapper || !this.afterEl || !this.handle) return;

      this.isDragging = false;

      this.handle.addEventListener('pointerdown', (e) => {
        this.isDragging = true;
        this.handle.setPointerCapture(e.pointerId);
        e.preventDefault();
      });

      this.wrapper.addEventListener('pointermove', (e) => {
        if (!this.isDragging) return;
        this.#updatePosition(e);
      });

      this.wrapper.addEventListener('pointerup', () => { this.isDragging = false; });
      this.wrapper.addEventListener('pointercancel', () => { this.isDragging = false; });

      this.wrapper.addEventListener('click', (e) => {
        if (e.target === this.handle || this.handle.contains(e.target)) return;
        this.#updatePosition(e);
      });

      this.handle.addEventListener('keydown', (e) => {
        const current = parseFloat(this.handle.style.left) || 50;
        let next = current;
        if (e.key === 'ArrowLeft') next = Math.max(0, current - 2);
        else if (e.key === 'ArrowRight') next = Math.min(100, current + 2);
        else return;
        e.preventDefault();
        this.#setPosition(next);
      });
    }

    #updatePosition(e) {
      const rect = this.wrapper.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
      this.#setPosition(pct);
    }

    #setPosition(pct) {
      this.handle.style.left = `${pct}%`;
      this.afterEl.style.clipPath = `inset(0 0 0 ${pct}%)`;
      this.handle.setAttribute('aria-valuenow', Math.round(pct));
    }
  }

  customElements.define('before-after-component', BeforeAfterComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight-sticky"] && !Shopify.designMode) return;
  try {
    
  class SpotlightFeatureComponent extends HTMLElement {
    connectedCallback() {
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('spotlight__feature--visible');
          }
        }
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('spotlight-feature-component', SpotlightFeatureComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-stats-split"] && !Shopify.designMode) return;
  try {
    
  class StatsResultItem extends HTMLElement {
    connectedCallback() {
      this.numberEl = this.querySelector('[data-ref="number"]');
      if (!this.numberEl) return;

      this.target = parseFloat(this.dataset.target) || 0;
      this.decimals = parseInt(this.dataset.decimals, 10) || 0;

      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.#animate();
            this.observer.disconnect();
          }
        }
      }, { threshold: 0.3 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    #animate() {
      const start = performance.now();
      const duration = 1800;
      const target = this.target;
      const decimals = this.decimals;
      const el = this.numberEl;

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = eased * target;
        el.textContent = decimals > 0 ? current.toFixed(decimals) : Math.floor(current).toLocaleString();
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    }
  }

  customElements.define('stats-result-item', StatsResultItem);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-timeline"] && !Shopify.designMode) return;
  try {
    
  class ResultsTlStep extends HTMLElement {
    connectedCallback() {
      this.index = this.dataset.index;
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('results-tl__step--visible');
            const section = entry.target.closest('.results-tl');
            if (!section) return;
            const allMedia = section.querySelectorAll('[data-media-index]');
            for (const media of allMedia) {
              media.classList.toggle('results-tl__media-item--active', media.dataset.mediaIndex === this.index);
            }
          }
        }
      }, { threshold: 0.5 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('results-tl-step', ResultsTlStep);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    
  class StatsCounterItem extends HTMLElement {
    connectedCallback() {
      this.numberEl = this.querySelector('[data-ref="number"]');
      if (!this.numberEl) return;

      this.target = parseFloat(this.dataset.target) || 0;
      this.duration = parseInt(this.dataset.duration, 10) || 2000;
      this.decimals = parseInt(this.dataset.decimals, 10) || 0;

      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.#animate();
            this.observer.disconnect();
          }
        }
      }, { threshold: 0.3 });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    #animate() {
      const start = performance.now();
      const target = this.target;
      const duration = this.duration;
      const decimals = this.decimals;
      const el = this.numberEl;

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = eased * target;
        el.textContent = decimals > 0
          ? current.toFixed(decimals)
          : Math.floor(current).toLocaleString();
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    }
  }

  customElements.define('stats-counter-item', StatsCounterItem);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-masonry"] && !Shopify.designMode) return;
  try {
    
  class MasonryCardComponent extends HTMLElement {
    connectedCallback() {
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('masonry-testimonials__card--visible');
            this.observer.unobserve(entry.target);
          }
        }
      }, { threshold: 0.15 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('masonry-card-component', MasonryCardComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-brand-story"] && !Shopify.designMode) return;
  try {
    
  class TimelineItemComponent extends HTMLElement {
    connectedCallback() {
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('timeline__item--visible');
            this.observer.unobserve(entry.target);
          }
        }
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('timeline-item-component', TimelineItemComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  class VideoTestimonialCard extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.playBtn = this.querySelector('[data-ref="play"]');
      this.isPlaying = false;

      this.playBtn?.addEventListener('click', () => this.#toggle());
      this.video?.addEventListener('click', () => this.#toggle());
    }

    #toggle() {
      if (!this.video) return;
      if (this.isPlaying) {
        this.video.pause();
        this.playBtn?.classList.remove('video-testimonials__play--hidden');
      } else {
        this.video.muted = false;
        this.video.play();
        this.playBtn?.classList.add('video-testimonials__play--hidden');
      }
      this.isPlaying = !this.isPlaying;
    }
  }

  customElements.define('video-testimonial-card', VideoTestimonialCard);

  } catch(e) { console.error(e); }
})();
})();
